// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"42":"c5dc0d95","79":"e5048055","245":"e5048055","480":"e022705b","631":"e5048055","642":"c5dc0d95","717":"dfcf6833","876":"50565aee","915":"e5048055","960":"e5048055","970":"50565aee"}[chunkId] + ".css";
};